import React from 'react'
import { Typography, Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { PriceComponent } from '../../types/page'
import Link from '../Link'
import useDiscountToken from '../../hooks/useDiscountToken'
import useDiscountCode from '../../hooks/useDiscountCode'
import Affirm from '../Affirm'

interface PriceInsertProps {
  item: PriceComponent
  children: React.ReactNode
}

export const PriceInsert: React.FC<PriceInsertProps> = ({ item }) => {
  const { classes } = useStyles()
  const discountToken = useDiscountToken()
  const planCode = item.url
    .substring(item.url.lastIndexOf('/') + 1)
    .split('?')[0]
  const { isLoading, isError, data } = useDiscountCode(planCode, discountToken)

  if (!discountToken || isLoading || isError || !data) {
    return (
      <>
        <Typography
          className={classes.linkPrice}
          component={'span'}
          variant="h2"
        >
          <Link href={item.url}>${item.price}</Link>
        </Typography>
        <Box className={classes.priceContainer}>
          <Affirm price={parseInt(item.price)} planCode={planCode} />
        </Box>
      </>
    )
  }

  return (
    <Box>
      <Typography component={'span'} className={classes.linkPrice} variant="h2">
        <Link href={`${item.url}?dt=${discountToken}`}>
          ${data.sticker_price - data.discount_value}
        </Link>
      </Typography>
      <Typography
        component={'span'}
        className={classes.originalPrice}
        variant="h3"
      >
        ${item.price}
      </Typography>
    </Box>
  )
}

const useStyles = makeStyles()((theme) => ({
  priceContainer: {
    minHeight: '1.375rem',
  },
  originalPrice: {
    '&&': {
      color: theme.palette.secondary.dark,
      position: 'relative',
      lineHeight: '1',
      marginLeft: '0.75rem',
      bottom: '0.2rem',

      '&::after': {
        content: '""',
        display: 'block',
        backgroundColor: theme.palette.secondary.dark,
        width: '110%',
        position: 'absolute',
        top: '40%',
        left: '50%',
        height: '2px',
        marginLeft: '-55%',
      },
    },
  },
  price: {
    fontSize: 'inherit',
  },
  linkPrice: {
    lineHeight: '1',
    '& a': {
      textDecoration: 'none',
      color: 'inherit',
      '&:active': {
        textDecoration: 'none',
        color: 'inherit',
      },
      '&:hover': {
        textDecoration: 'none',
        color: 'inherit',
      },
    },
  },
}))

export default PriceInsert
